export const errorMessageUserIsDealer =
    'A payment could not be calculated based on the added trade-in value. Try removing the trade-in to receive a payment. ';
export const getErrorMessageUserIsNotDealer = (dealerPhoneNumber: string) =>
    `Oops, We couldn't calculate a monthly payment based on your trade-in value. Try removing your trade to receive a payment or contact us at ${dealerPhoneNumber}. `;
